import React from 'react';

import {
    makeStyles,
    Typography
} from '@material-ui/core';

import { EnlaceFavorito } from './EnlaceFavorito';

const useEstilos = makeStyles((theme) => ({
    enlacesFavoritosSeccionContainer: {

    },
    titulo: {
        color: theme.palette.primary.main,
        padding: '0.5rem 0',
        fontWeight: 900,
        textTransform: "capitalize"
    },
    listaEnlaces: {
        padding: '0.3rem 0',
        color: '#888',
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            marginLeft: '4px',
            color: '#606060',
            '&:hover': {
                color: '#919191',
            },
            '&:focus, &:active': {
                color: '#DC0028',
            },
        }
    }, 
    cabecera: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    }

}));

interface Props {
    item: any;
}

export const EnlacesFavoritosSeccion = ( { item }: Props) => {
    const clases = useEstilos();

    return (
        <div>
            <div className={clases.cabecera}>
                <Typography variant="caption" component="div" classes={{ root: clases.titulo }}>{item.titulo}</Typography>
            </div>
            {item.enlaces.map((item: any) => (
                <div className={clases.listaEnlaces} key={item.Url}>
                    <EnlaceFavorito enlace={item} />
                </div>
                )
            )}
        </div>
    )
}